import React from "react";

export const VectorHamburgerIcon = () => {
  return (
    <svg
      width="25"
      height="16"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H18V2H0V0ZM0 5H18V7H0V5ZM0 10H18V12H0V10Z"/>
    </svg>
  );
};

export default VectorHamburgerIcon;
